const statistics = {
  en: {
    title: 'Analytics',
    subtitle: 'Platform-wide performance overview',
    subtitleOwn: 'Performance overview of your courses',

    period7d: '7 days',
    period30d: '30 days',
    period90d: '90 days',
    period1y: '1 year',
    periodAria: 'Period',

    kpiTotalUsers: 'Total users',
    kpiActiveSub: '{count} active (30 days)',
    kpiNewUsers: 'New users',
    kpiNewUsersSub: 'in the last {period}',
    kpiActiveUsers: 'Active users',
    activeUsersHint: 'last 30 days · {pct}',
    activeUsersWindow: 'last 30 days',
    kpiArpu: 'ARPU',
    kpiArpuSub: 'avg revenue per user',
    kpiTotalEnrollments: 'Total enrollments',
    kpiCompletionRateSub: '{pct} completion rate',
    kpiTotalCourses: 'Total courses',
    kpiPublishedSub: '{count} published',
    kpiAvgRating: 'Average rating',
    kpiAvgRatingSub: 'across all courses',
    kpiTotalRevenue: 'Total revenue',
    kpiOrdersSub: '{count} orders',

    sectionRevenue: 'Revenue',
    sectionUsers: 'Users',
    sectionCoursePerformance: 'Course performance',
    sectionEngagement: 'Engagement',

    revenueTrend: 'Revenue trend',
    revenueTrendSub: 'Completed sales, UZS',
    periodTotal: 'Past {period}: {amount}',
    byProvider: 'Payment methods',
    noRevenueTitle: 'No revenue in this period',
    noRevenueDesc: 'Try a different time range or wait for new orders.',
    noProviderData: 'No payments yet',
    unknownProvider: 'Unknown',
    providerClick: 'Click',
    providerPayme: 'Payme',
    revenueSeriesName: 'Revenue',
    orders: 'Orders',
    totalOrders: 'Total orders',
    avgOrderValue: 'Average order',

    userGrowth: 'User growth',
    userGrowthSub: 'New sign-ups per day',
    noGrowthData: 'No sign-ups in this period',
    usersSeriesName: 'New users',
    usersUnit: '{count} users',
    usersByRole: 'Users by role',
    donutTotal: 'total',
    noRoleData: 'No role data',
    roleMentor: 'Mentor',
    roleModerator: 'Moderator',

    publishedOf: '{published} of {total} courses published',
    noCourseData: 'No course data',
    colCourse: 'Course',
    colEnrollments: 'Enrollments',
    colCompletion: 'Completion',
    colRevenue: 'Revenue',
    unknownCourse: 'Untitled course',

    lessonViews: 'Lesson views',
    avgWatchTime: 'Average watch time',
    minutesUnit: '{count} min',
    perLesson: 'per lesson',
    assignmentCompletion: 'Assignment completion',
    examPassRate: 'Exam pass rate',
    feedbacks: 'Feedback',
    avgFeedbackRating: 'Average feedback rating',
    outOf5: 'out of 5',

    studentStatus: {
      title: 'Student status',
      subtitle: 'Students assigned to you, sorted by risk severity',
      courseLabel: 'Course',
      courseFilterAriaLabel: 'Course filter',
      allCourses: 'All courses',
      riskLabel: 'Risk',
      lastActivityLabel: 'Last activity',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      clearFilters: 'Clear all filters',
      tryAgain: 'Try again',
      unableToLoad: 'Unable to load student list. Please try again.',
      colName: 'Name',
      colRiskScore: 'Risk score',
      colTrend: 'Trend',
      colTopConcern: 'Top concern',
      colLastActivity: 'Last activity',
      colLastAssessed: 'Last assessed',
      noMatchFilters: 'No students match the selected filters.',
      noStudentsAssigned: 'No students assigned to you yet.',
      noStudentsAssignedDesc: 'When a teacher assigns students to you, they will appear here.',
      previous: 'Previous',
      next: 'Next',
      pageInfo: 'Page {current} of {total}',
      riskScoreTitle: 'Risk score: {score}',
      riskScoreValue: '{score}/10',
      noData: 'No data',
      viewDetailsFor: 'View details for {name}',
      trendRising: 'Rising',
      trendFalling: 'Falling',
      trendStable: 'Stable',
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: '{count} days ago',
      weekAgoOne: '{count} week ago',
      weekAgoOther: '{count} weeks ago',
      monthAgoOne: '{count} month ago',
      monthAgoOther: '{count} months ago',
    },
  },
  ru: {
    title: 'Аналитика',
    subtitle: 'Обзор эффективности всей платформы',
    subtitleOwn: 'Обзор эффективности ваших курсов',

    period7d: '7 дней',
    period30d: '30 дней',
    period90d: '90 дней',
    period1y: '1 год',
    periodAria: 'Период',

    kpiTotalUsers: 'Всего пользователей',
    kpiActiveSub: '{count} активных (30 дней)',
    kpiNewUsers: 'Новые пользователи',
    kpiNewUsersSub: 'за последние {period}',
    kpiActiveUsers: 'Активные пользователи',
    activeUsersHint: 'за 30 дней · {pct}',
    activeUsersWindow: 'за 30 дней',
    kpiArpu: 'ARPU',
    kpiArpuSub: 'средний доход на пользователя',
    kpiTotalEnrollments: 'Всего записей',
    kpiCompletionRateSub: '{pct} завершения',
    kpiTotalCourses: 'Всего курсов',
    kpiPublishedSub: '{count} опубликовано',
    kpiAvgRating: 'Средний рейтинг',
    kpiAvgRatingSub: 'по всем курсам',
    kpiTotalRevenue: 'Общий доход',
    kpiOrdersSub: '{count} заказов',

    sectionRevenue: 'Доход',
    sectionUsers: 'Пользователи',
    sectionCoursePerformance: 'Эффективность курсов',
    sectionEngagement: 'Вовлечённость',

    revenueTrend: 'Динамика дохода',
    revenueTrendSub: 'Завершённые продажи, сум',
    periodTotal: 'За {period}: {amount}',
    byProvider: 'Способы оплаты',
    noRevenueTitle: 'За этот период дохода нет',
    noRevenueDesc: 'Попробуйте другой период или дождитесь новых заказов.',
    noProviderData: 'Платежей пока нет',
    unknownProvider: 'Неизвестно',
    providerClick: 'Click',
    providerPayme: 'Payme',
    revenueSeriesName: 'Доход',
    orders: 'Заказы',
    totalOrders: 'Всего заказов',
    avgOrderValue: 'Средний чек',

    userGrowth: 'Рост пользователей',
    userGrowthSub: 'Новые регистрации по дням',
    noGrowthData: 'За этот период регистраций не было',
    usersSeriesName: 'Новые пользователи',
    usersUnit: '{count} пользователей',
    usersByRole: 'Пользователи по ролям',
    donutTotal: 'всего',
    noRoleData: 'Нет данных по ролям',
    roleMentor: 'Ментор',
    roleModerator: 'Модератор',

    publishedOf: 'Опубликовано {published} из {total} курсов',
    noCourseData: 'Нет данных по курсам',
    colCourse: 'Курс',
    colEnrollments: 'Записи',
    colCompletion: 'Завершение',
    colRevenue: 'Доход',
    unknownCourse: 'Курс без названия',

    lessonViews: 'Просмотры уроков',
    avgWatchTime: 'Среднее время просмотра',
    minutesUnit: '{count} мин',
    perLesson: 'на урок',
    assignmentCompletion: 'Выполнение заданий',
    examPassRate: 'Процент сдачи экзаменов',
    feedbacks: 'Отзывы',
    avgFeedbackRating: 'Средняя оценка отзывов',
    outOf5: 'из 5',

    studentStatus: {
      title: 'Статус учеников',
      subtitle: 'Ученики, закреплённые за вами, отсортированы по уровню риска',
      courseLabel: 'Курс',
      courseFilterAriaLabel: 'Фильтр курсов',
      allCourses: 'Все курсы',
      riskLabel: 'Риск',
      lastActivityLabel: 'Последняя активность',
      days7: '7 дней',
      days30: '30 дней',
      days90: '90 дней',
      clearFilters: 'Сбросить все фильтры',
      tryAgain: 'Повторить попытку',
      unableToLoad: 'Не удалось загрузить список учеников. Попробуйте ещё раз.',
      colName: 'Имя',
      colRiskScore: 'Оценка риска',
      colTrend: 'Тренд',
      colTopConcern: 'Основная проблема',
      colLastActivity: 'Последняя активность',
      colLastAssessed: 'Последняя оценка',
      noMatchFilters: 'Нет учеников, соответствующих выбранным фильтрам.',
      noStudentsAssigned: 'За вами пока не закреплено ни одного ученика.',
      noStudentsAssignedDesc: 'Когда преподаватель закрепит за вами учеников, они появятся здесь.',
      previous: 'Назад',
      next: 'Далее',
      pageInfo: 'Страница {current} из {total}',
      riskScoreTitle: 'Оценка риска: {score}',
      riskScoreValue: '{score}/10',
      noData: 'Нет данных',
      viewDetailsFor: 'Просмотреть детали для {name}',
      trendRising: 'Растёт',
      trendFalling: 'Снижается',
      trendStable: 'Стабильно',
      today: 'Сегодня',
      yesterday: 'Вчера',
      daysAgo: '{count} дн. назад',
      weekAgoOne: '{count} неделю назад',
      weekAgoOther: '{count} недель назад',
      monthAgoOne: '{count} месяц назад',
      monthAgoOther: '{count} месяцев назад',
    },
  },
  uz: {
    title: 'Tahlil',
    subtitle: "Platforma bo'yicha umumiy ko'rsatkichlar",
    subtitleOwn: "Kurslaringiz bo'yicha umumiy ko'rsatkichlar",

    period7d: '7 kun',
    period30d: '30 kun',
    period90d: '90 kun',
    period1y: '1 yil',
    periodAria: 'Davr',

    // soft hyphen: in a narrow phone tile the word breaks as "Foydalanuv-" / "chilar", not mid-letter
    kpiTotalUsers: 'Foydalanuv\u00ADchilar',
    kpiActiveSub: '{count} ta faol (30 kun)',
    kpiNewUsers: 'Yangi foydalanuvchilar',
    kpiNewUsersSub: "so'nggi {period} ichida",
    kpiActiveUsers: 'Faol foydalanuvchilar',
    activeUsersHint: "so'nggi 30 kun · {pct}",
    activeUsersWindow: "so'nggi 30 kun",
    kpiArpu: 'ARPU',
    kpiArpuSub: "foydalanuvchi boshiga o'rtacha daromad",
    kpiTotalEnrollments: 'Jami yozilishlar',
    kpiCompletionRateSub: '{pct} tugatish darajasi',
    kpiTotalCourses: 'Jami kurslar',
    kpiPublishedSub: '{count} nashr etilgan',
    kpiAvgRating: "O'rtacha reyting",
    kpiAvgRatingSub: "barcha kurslar bo'yicha",
    kpiTotalRevenue: 'Jami daromad',
    kpiOrdersSub: '{count} buyurtma',

    sectionRevenue: 'Daromad',
    sectionUsers: 'Foydalanuvchilar',
    sectionCoursePerformance: 'Kurslar samaradorligi',
    sectionEngagement: 'Faollik',

    revenueTrend: 'Daromad dinamikasi',
    revenueTrendSub: "Yakunlangan sotuvlar, so'm",
    periodTotal: "So'nggi {period} ichida: {amount}",
    byProvider: "To'lov usullari",
    noRevenueTitle: "Bu davrda daromad yo'q",
    noRevenueDesc: "Boshqa vaqt oralig'ini tanlang yoki yangi buyurtmalarni kuting.",
    noProviderData: "Hali to'lovlar yo'q",
    unknownProvider: "Noma'lum",
    providerClick: 'Click',
    providerPayme: 'Payme',
    revenueSeriesName: 'Daromad',
    orders: 'Buyurtmalar',
    totalOrders: 'Jami buyurtmalar',
    avgOrderValue: "O'rtacha chek",

    userGrowth: "Foydalanuvchilar o'sishi",
    userGrowthSub: "Kunlik yangi ro'yxatdan o'tganlar",
    noGrowthData: "Bu davrda ro'yxatdan o'tganlar yo'q",
    usersSeriesName: 'Yangi foydalanuvchilar',
    usersUnit: '{count} foydalanuvchi',
    usersByRole: "Rol bo'yicha",
    donutTotal: 'jami',
    noRoleData: "Rol ma'lumotlari yo'q",
    roleMentor: 'Mentor',
    roleModerator: 'Moderator',

    publishedOf: '{total} ta kursdan {published} tasi nashr etilgan',
    noCourseData: "Kurs ma'lumotlari yo'q",
    colCourse: 'Kurs',
    colEnrollments: 'Yozilishlar',
    colCompletion: 'Tugatish',
    colRevenue: 'Daromad',
    unknownCourse: 'Nomsiz kurs',

    lessonViews: "Dars ko'rishlari",
    avgWatchTime: "O'rtacha ko'rish vaqti",
    minutesUnit: '{count} daq',
    perLesson: 'har bir darsga',
    assignmentCompletion: 'Topshiriqlarni bajarish',
    examPassRate: 'Imtihon topshirish darajasi',
    feedbacks: 'Fikr-mulohazalar',
    avgFeedbackRating: "O'rtacha fikr-mulohaza bahosi",
    outOf5: '5 dan',

    studentStatus: {
      title: 'O\'quvchilar holati',
      subtitle: 'Sizga biriktirilgan o\'quvchilar, xavf darajasi bo\'yicha saralangan',
      courseLabel: 'Kurs',
      courseFilterAriaLabel: 'Kurs filtri',
      allCourses: 'Barcha kurslar',
      riskLabel: 'Xavf',
      lastActivityLabel: 'Oxirgi faollik',
      days7: '7 kun',
      days30: '30 kun',
      days90: '90 kun',
      clearFilters: 'Barcha filtrlarni tozalash',
      tryAgain: 'Qayta urinish',
      unableToLoad: 'O\'quvchilar ro\'yxatini yuklab bo\'lmadi. Qayta urinib ko\'ring.',
      colName: 'Ism',
      colRiskScore: 'Xavf bahosi',
      colTrend: 'Tendensiya',
      colTopConcern: 'Asosiy muammo',
      colLastActivity: 'Oxirgi faollik',
      colLastAssessed: 'Oxirgi baholash',
      noMatchFilters: 'Tanlangan filtrlarga mos o\'quvchilar topilmadi.',
      noStudentsAssigned: 'Sizga hali hech qanday o\'quvchi biriktirilmagan.',
      noStudentsAssignedDesc: 'O\'qituvchi sizga o\'quvchilarni biriktirganida, ular bu yerda ko\'rinadi.',
      previous: 'Oldingi',
      next: 'Keyingi',
      pageInfo: '{total} dan {current} sahifa',
      riskScoreTitle: 'Xavf bahosi: {score}',
      riskScoreValue: '{score}/10',
      noData: 'Ma\'lumot yo\'q',
      viewDetailsFor: '{name} tafsilotlarini ko\'rish',
      trendRising: 'O\'smoqda',
      trendFalling: 'Pasaymoqda',
      trendStable: 'Barqaror',
      today: 'Bugun',
      yesterday: 'Kecha',
      daysAgo: '{count} kun oldin',
      weekAgoOne: '{count} hafta oldin',
      weekAgoOther: '{count} hafta oldin',
      monthAgoOne: '{count} oy oldin',
      monthAgoOther: '{count} oy oldin',
    },
  },
};

export default statistics;
